import React, { useEffect, useRef, useState } from "react";
import "./Templates.css";
import Container from "react-bootstrap/Container";
import { Row, Col, Modal, Button, Form } from "react-bootstrap";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { AutoComplete } from "@progress/kendo-react-dropdowns";
import {
  AssignFormTemplateToCustomer,
  GetAllFormTemplates,
} from "../../apis/FormAPI";
import { SearchCustomerNames } from "../../apis/CustomerAPI";
import "@progress/kendo-theme-default/dist/all.css";
import * as AiIcons from "react-icons/ai";
import * as MdIcons from "react-icons/md";
import * as FiIcons from "react-icons/fi";
import { Link } from "react-router-dom";
import ApplicantForm from "../../qcr-common/ApplicantForm";
import ReactDOMServer from "react-dom/server";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useAlert } from "react-alert";

export default function FormTemplates() {
  const pdfExportComponent = useRef(null);
  const [show, setShow] = useState(false);
  const [formShow, setFormShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleFormClose = () => setFormShow(false);
  const handleFormShow = () => setFormShow(true);
  const [data, setData] = useState([]);
  const [customerData, setCustomerData] = useState([]);

  const [templateId, setTemplateId] = useState(0);
  const [templateName, setTemplateName] = useState("");
  const [customerId, setCustomerId] = useState(0);
  const [customerName, setCustomerName] = useState("");
  const [formName, setFormName] = useState("");
  const alert = useAlert();
  const [startDownloading, setStartDownloading] = useState(false);

  const exportPDFWithComponent = (id, name) => {
    setTemplateId(id);
    setFormName(name);
    handleFormShow();
  };

  useEffect(() => {
    console.log("start downloading", startDownloading);
    if (pdfExportComponent.current && startDownloading) {
      pdfExportComponent.current.save();
      setTimeout(() => {
        handleFormClose();
      }, 3000);
    }
  }, [startDownloading]);

  useEffect(() => {
    async function GetFormTemplateData() {
      setData(await GetAllFormTemplates());
    }
    GetFormTemplateData();
  }, []);

  function assignForm(id) {
    var formData = data.data.filter((d) => d.id === id);
    setTemplateId(id);
    setTemplateName(formData[0].templateName);
    setCustomerId(0);
    setCustomerName("");
    setFormName("");

    handleShow();
  }

  const getCustomerNames = async (e) => {
    var name = e.target.value;
    var custObj = e.target.props.data;
    const cust = custObj.filter((c) => c.customerName === name);
    if (cust.length > 0) {
      setCustomerId(cust[0].customerId);
    }
    setCustomerName(name);
    if (name.length > 2) {
      var result = await SearchCustomerNames(name);
      setCustomerData(result.data);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (customerId !== 0 && formName !== "") {
      var reqBody = {
        id: 0,
        totalRows: 0,
        formName: formName,
        formTemplateId: templateId,
        customerId: customerId,
      };

      var result = await AssignFormTemplateToCustomer(reqBody);
      console.log(result);
      if (result.status === 200) {
        alert.success("Form assigned to customer");
      } else alert.success("Unable to assign form to customer");
    } else {
      alert.success("Fill all the fields");
    }

    handleClose();
  };

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="admin-page-row orders">
                  <Col lg={6} md={6} sm={12}>
                    <div className="page-title">
                      <h2>Form Templates</h2>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <div className="search-filter"></div>
                  </Col>
                </Row>
                <Row>
                  <Grid style={{ height: "75vh" }} data={data} sortable={true}>
                    <GridColumn field="id" title="Template ID" width="120px" />
                    <GridColumn field="templateName" title="Form Name" />
                    <GridColumn
                      field="id"
                      title="View"
                      width="100px"
                      cell={(props) => (
                        <td className="req">
                          <Link
                            to={"/Form?token=preview&id=" + props.dataItem.id}
                            target="_blank"
                          >
                            <AiIcons.AiOutlineEye />
                          </Link>
                        </td>
                      )}
                    />
                    <GridColumn
                      field="id"
                      title="Assign"
                      width="100px"
                      cell={(props) => (
                        <td className="act">
                          <button
                            type="btn"
                            onClick={() => assignForm(props.dataItem.id)}
                          >
                            <MdIcons.MdOutlineAssignmentTurnedIn />
                          </button>
                        </td>
                      )}
                    />
                    <GridColumn
                      field="id"
                      title="Download"
                      width="120px"
                      cell={(props) => (
                        <td className="act">
                          <button
                            type="btn"
                            onClick={() =>
                              exportPDFWithComponent(
                                props.dataItem.id,
                                props.dataItem.templateName
                              )
                            }
                          >
                            <FiIcons.FiDownload />
                          </button>
                        </td>
                      )}
                    />
                  </Grid>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
      <Modal show={formShow} onHide={handleFormClose} fullscreen>
        <Modal.Body>
          <PDFExport
            ref={pdfExportComponent}
            paperSize="A4"
            margin={40}
            fileName={`${formName} Form`}
          >
            <ApplicantForm
              token="preview_download"
              templateid={templateId}
              viewLoaded={(loaded) => {
                console.log(loaded);
              }}
              previewLoaded={(previewLoaded) => {
                setStartDownloading(previewLoaded);
              }}
            />
          </PDFExport>
        </Modal.Body>
      </Modal>

      <Modal centered show={show} onHide={handleClose}>
        <Modal.Body className="invest-modal">
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicSelect">
              <Row>
                <Col lg={4} md={12}>
                  <Form.Label>Form Template:</Form.Label>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Control
                    type="text"
                    placeholder="Form Template"
                    value={templateName}
                    required
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicSelect">
              <Row>
                <Col lg={4} md={12}>
                  <Form.Label>Customer:</Form.Label>
                </Col>
                <Col lg={8} md={12}>
                  <AutoComplete
                    className="custom-select-form-control"
                    data={customerData}
                    placeholder="Customer Name"
                    textField="customerName"
                    value={customerName}
                    onChange={getCustomerNames}
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicText">
              <Row>
                <Col lg={4} md={12}>
                  <Form.Label>Form Name:</Form.Label>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Control
                    type="text"
                    placeholder="Custom Form Name"
                    value={formName}
                    onChange={(e) => setFormName(e.target.value)}
                    required
                  />
                </Col>
              </Row>
            </Form.Group>

            <Row className="ordbtn">
              <Col lg={6} md={12} className="btorng">
                <Button type="submit">Assign</Button>
              </Col>
              <Col lg={6} md={12} className="btgry">
                <Button onClick={handleClose}>Cancel</Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
